
import {Component, Prop, Vue} from "vue-property-decorator";
import LoyaltySubscriptionTypeUpdateForm from "@/form/loyalty/loyaltySubscriptionType/LoyaltySubscriptionTypeUpdateForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
@Component({
  components: {FormGroup},
})
export default class LoyaltySubscriptionTypeUpdateFormComponent extends Vue {
  @Prop() form!: LoyaltySubscriptionTypeUpdateForm;

}
